import { z } from 'zod';

/**
 * USPS state and territory abbreviations accepted for coach resident region.
 * Includes the 50 states, DC, and US territories from the USPS STATE (TERRITORY) list.
 */
export const coachRegionSchema = z.enum([
  // States
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  // District / territories
  'DC',
  'AS',
  'GU',
  'MP',
  'PR',
  'VI',
]);
export type CoachRegion = z.infer<typeof coachRegionSchema>;
export const CoachRegion = coachRegionSchema.enum;
export const coachRegionOptions = coachRegionSchema.options;

const validCoachRegions = new Set<string>(coachRegionOptions);

/**
 * Parse an Airtable / free-text resident-region value to a USPS abbreviation, or null.
 * Empty, unknown, and non-US values (e.g. "Canada") become null without throwing.
 */
export function coachRegionFromInput(value: string | null | undefined): CoachRegion | null {
  const normalized = value?.trim().toUpperCase();
  if (!normalized) {
    return null;
  }
  return validCoachRegions.has(normalized) ? (normalized as CoachRegion) : null;
}
